export const API_BASE =
  process.env.NEXT_PUBLIC_API_BASE_URL ?? "https://api.audiohawk.io";

function authHeader() {
  if (typeof window === "undefined") {
    return {};
  }
  const token = localStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(body),
    credentials: "include"
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error ?? "Request failed");
  }

  return data as T;
}

export async function apiGet<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "GET",
    headers: {
      ...authHeader()
    },
    credentials: "include"
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error ?? "Request failed");
  }

  return data as T;
}

export function startGoogleAuth() {
  window.location.href = `${API_BASE}/v1/auth/google`;
}
